module.exports = __webpack_public_path__ + "img/creditPicture12.68245fda.png";